import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberVisible = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M4.541 11.253C7.041 9.009 10.842 6.75 16 6.75s8.959 2.26 11.459 4.503a20.4 20.4 0 0 1 2.796 3.084 17 17 0 0 1 .872 1.314q.03.05.045.08l.012.021.004.006v.002l.001.001-.439.239.44.239h-.001l-.001.003-.004.006-.012.022a7 7 0 0 1-.221.37c-.156.25-.387.602-.696 1.023a20.4 20.4 0 0 1-2.796 3.084c-2.5 2.244-6.302 4.503-11.459 4.503-5.158 0-8.959-2.26-11.459-4.503a20.4 20.4 0 0 1-2.796-3.084 17 17 0 0 1-.872-1.314l-.045-.08-.012-.021-.004-.006v-.002l-.001-.001L1.25 16l-.44-.239h.001l.001-.003.004-.006.012-.022.045-.08q.06-.104.177-.29c.155-.25.386-.602.695-1.023a20.4 20.4 0 0 1 2.796-3.084M1.25 16l-.44-.239a.5.5 0 0 0 0 .477zm.58 0 .068.111c.143.23.361.561.654.96a19.4 19.4 0 0 0 2.657 2.932C7.584 22.134 11.158 24.25 16 24.25s8.416-2.116 10.791-4.247a19.4 19.4 0 0 0 2.657-2.931A16 16 0 0 0 30.171 16l-.069-.111a16 16 0 0 0-.654-.96 19.4 19.4 0 0 0-2.657-2.932C24.416 9.866 20.843 7.75 16 7.75c-4.842 0-8.416 2.116-10.791 4.247a19.4 19.4 0 0 0-2.657 2.932A16 16 0 0 0 1.829 16m28.92 0 .44.238a.5.5 0 0 0 0-.476z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M16 9.75a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-7 6a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M14.1 13.917a.5.5 0 0 1 .183.683 2.099 2.099 0 0 0 1.818 3.15.5.5 0 0 1-.001 1 3.098 3.098 0 0 1-2.683-4.65.5.5 0 0 1 .683-.183",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberVisible;
